<div class="sidebar-header">{{ headerContent }}</div>
<form class="standard-form" (ngSubmit)="onSubmit()" [formGroup]="initiativeForm">
  <div class="sans-margin">
    <p *ngIf="!isEdit">Add a Critical Initiative for the following Objective:</p>
    <p auto="obj-name-ci-modal">{{objectiveText}}</p>
  </div>
  <label class="standard-label" for="initiativeDescription">Critical Initiative</label>
  <div class="input-error-wrap sans-margin">
    <textarea auto="ci-description-field" pInputTextarea class="text-area" id="initiativeDescription"
              name="initiative description" placeholder="Enter Critical Initiative here"
              [formControl]="description" [maxlength]="MAX_DESCRIPTION_LENGTH">
    </textarea>
    <div class="remaining-msg">Remaining: {{ descriptionRemainingCharacters }}</div>
    <app-error-msg [control]="description" [show]="description.invalid && description.touched && description.dirty">
    </app-error-msg>
  </div>
  <label class="standard-label" for="initiativeTag">Select a Tag</label>
  <div class="sans-margin">
    <p-dropdown auto="ci-tag-dropdown" class="standard-input block" id="initiativeTag" name="initiative tag"
                [autoWidth]="false" [options]="tagSelectItems" [formControl]="tag">
    </p-dropdown>
    <app-error-msg [control]="tag" [show]="tag.invalid && tag.touched && tag.dirty"></app-error-msg>
  </div>
  <div class="button-row">
    <button auto="ci-cancel-btn" class="btn btn-alt left-btn" type="button" (click)="cancel.emit()">Cancel</button>
    <button auto="ci-save-btn" class="btn" type="submit" [disabled]="isSubmitDisabled">Save</button>
  </div>
</form>
